// extracted by mini-css-extract-plugin
export default {"root":"locale_select_mobile_root__MlZYV","select":"locale_select_mobile_select__khOYb"};